module.exports = __webpack_public_path__ + "static/media/welcome-to.37681dfb.png";